import React, { Component } from 'react';
import Header from '../../components/main.header.component';
import Modal from '../Modal';


class MotoTrip extends Component {
  constructor(){
    super();
    this.state = {
      isOpen: false,
      url: ''
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0,0);
  }
  openModal (evt) {
    let url = evt.target.src;
    if(url){ // clicking the actual image opens the Modal, and not just Div padding
      this.setState({
        isOpen: true,
        url: url
      });
    }
  }

  closeModal (evt) {
    this.setState({
      isOpen: false,
      url: ''
    });
  }

  render() {
    return (
      <div className="moto-body">
        <Header
          props={this.props}
        />
        <div className="mototrip" style={{background: "url(/images/27.jpg) center center no-repeat"}}>
          <div id="header-moto">
            Always Head West<br/>
            <div id="moto-text">
              Selected photographs captured during<br /> a solo cross-country motorcycle trip.
            </div>
          </div>

        <div className="motozine">
          <a href="https://toobrothers.bigcartel.com/product/always-head-west" target="_blank" rel="noopener noreferrer">
            <div id="motozinetext-headline"> Now available in book form!</div>
            <img src="/images/Moto-Book.jpg" id="moto-book" alt=""/>
          </a>
          <div id="motozinetext">
            50 + page photo book with stories, experiences and images made during the trip <br />
            5"x8" size, black and white.<br />
            All photos captured on 35mm film, developed and scanned by hand.<br />
            Published and printed by
            <a href="http://www.irrelevantpress.com/" target="_blank" rel="noopener noreferrer">
              Irrelevant Press.
            </a>
          </div>
        </div>
        <div className="moto-responsive">
          <div className="moto-gallery">
            <div onClick={this.openModal}>
              <img src="/images/26.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
             <img src="/images/9.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
             <img src="/images/16.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
              <img src="/images/2.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
              <img src="/images/3.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
              <img src="/images/25.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
              <img src="/images/5.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
            <img src="/images/6.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
            <img src="/images/7.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
              <img src="/images/10.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
            <img src="/images/text3.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
          <div className="moto-gallery">
            <div onClick={this.openModal}>
              <img src="/images/11.jpg" id="moto-photo" alt=""/>
            </div>
          </div>
        </div>

          <Modal
            show={this.state.isOpen}
            onClose={this.closeModal}
            className="Modal-Backdrop" >
              <img
                className="moto-image"
                src={this.state.url}
                alt="mototrip"
              />

          </Modal>
        </div>
      </div>
    );
  }
}

export default MotoTrip;

